// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AudioService_wrapper__JmIC7"};